/**
 * This file contains constants related to subscription plans.
 * It defines the available subscription plan values used across the application.
 */
export const subValues = {
  Pro: "pro",
  Standard: "standard",
};
